<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      <v-row align="center" justify="center" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="mw-400">
            <v-skeleton-loader type="list-item-avatar, list-item-three-line, list-item-three-line, list-item-three-line, list-item-three-line" class="mb-3"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-center">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Osticket
      </div>
      <v-row align="center" justify="center" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="text-h3 text-primary mw-400 w-100 mb-5">
            Preencha os campos abaixo para realizar a integração.
          </div>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              class="mw-400"
              v-model="dados.cos_url"
              outlined
              label="URL"
            ></v-text-field>
          </v-row>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              v-model="dados.cos_api_token"
              outlined
              class="mw-400"
              label="API Token"
            ></v-text-field>
          </v-row>
          <v-row no-gutters class="mw-400 pb-10" justify="end">
            <v-btn
              :loading="loadingStore"
              :disabled="loadingStore"
              class="primary"
              @click="edit ? updateItem() : storeItem()"
            >{{edit ? 'Atualizar' : 'Salvar'}}</v-btn>
          </v-row>
          <v-row no-gutters class="mb-4 mt-10 mw-400">
            <v-text-field
              hide-details
              class=""
              :value="ip_saida"
              outlined
              id="ip_saida"
              readonly
              label="IP de saída"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('ip_saida')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
          <div class="text-white mw-400 w-100 mb-5 text-caption">
            *Copie e informe este IP no seu painel de configurações da OSTicket para liberar acesso do sistema a sua plataforma
          </div>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-center">
          <a href="https://osticket.com/" rel="noreferrer" target="_blank">
            <img class="mw_img" src="@assets/img/osticket_logo.png" alt="Logo Osticket">
          </a>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: false,
      ip_saida: '',
      dados: {
        uuid_cos_id: '',
        cos_url: '',
        cos_api_token: ''
      },
      loadingStore: false,
      edit: false
    }
  },
  methods: {
    copyItem (id) {
      let textoCopiado = document.getElementById(id)
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      try {
        var successful = document.execCommand('copy')
        this.$root.SnackControl.open(this, {
          text: successful ? 'Item copiado!' : 'Erro ao copiar!',
          color: 'success'
        })
      } catch (err) {
        this.$root.SnackControl.open(this, {
          text: 'Erro ao copiar!',
          color: 'error'
        })
      }
    },
    storeItem () {
      this.loadingStore = true
      Api.post('osticket', this.dados)
        .then(res => {
          this.edit = true
          this.$root.SnackControl.open(this, {
            text: res.data.message,
            color: 'success'
          })
          this.loadFunctions()
          this.loadingStore = false
        })
        .catch(err => {
          this.loadingStore = false
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao salvar dados!',
            color: 'error'
          })
        })
    },
    updateItem () {
      Api.post('osticket/atualiza', this.dados)
        .then(res => {
          this.edit = true
          this.$root.SnackControl.open(this, {
            text: res.data.message,
            color: 'success'
          })
          this.loadFunctions()
          this.loadingStore = false
        })
        .catch(err => {
          this.loadingStore = false
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao atualizar dados!',
            color: 'error'
          })
        })
    },
    loadFunctions () {
      this.getDados()
    },
    async getDados () {
      this.loading = true
      await Api.get('osticket')
        .then(res => {
          if (res.data.data) {
            this.dados = res.data.data
            this.ip_saida = this.dados.ip_saida

            delete this.dados.ip_saida
            if (this.dados.uuid_cos_id) {
              this.edit = true
            }
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
  @import "@scss/_variables.scss";
  @import "@scss/_ui.scss";
  .mw-400 {
    max-width: 400px;
  }
  .ui-btn-inherit {
    margin-bottom: 3px!important;
    min-height: 10px!important;
  }
  .mw_img {
    max-width: 200px;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Osticket.vue